import Vue from 'vue'
import moment from 'moment'

// Globally decleared Filters;
Vue.filter('trimStr',(inputStr)=>{
  return inputStr.trim();
});

Vue.filter('dateFilter', (date) => {
  return moment(String(date)).format('DD/MM/YYYY hh:mm A')
})

Vue.filter('orderDateFilter', (date) => {
  return moment(String(date)).format('DD-MM-YYYY HH:mm:ss') // 24 hour format eg 12-08-2020 17:22:44
})
Vue.filter('MM-DD-YYYY_FORMAT', (date) => {
  return moment(date, 'DD-MM-YYYY HH:mm:ss').format('LL') // Example Feb 25, 2020
})
Vue.filter('EmailAndMobileMask', (param) => {
  let user = JSON.parse(localStorage.getItem('userInfo'))
  if (user && user.department && user.department.departmentname !== 'customercare') {
    return '************'
  } else {
    return param || ''
  }
})
export default {
  MONTH_YEAR: function (date) {
    return moment(date).format('MMMM YYYY') // Example Feb 2020
  },
  dateFilter: function (date) {
    return moment(date).format('LLL')
  },
  timeStampDateFormat: function (date) {
    return moment(date).format('LLL')
  },
  formatDate: function (date) {
    if (!date) {
      return '-'
    } else {
      return moment(String(date)).format('LLL')
    }

    // return moment(String(date)).format(
    //   'DD/MM/YYYY hh:mm A')
  },
  formatOrderDate: function (date) {
    return moment(date, 'DD-MM-YYYY HH:mm:ss').format('LLL')
    // return moment(String(date)).format(
    //   'DD/MM/YYYY hh:mm:ss A')
  },
  formatOrderDateFilter: function (date) {
    return moment(date).format('DD-MM-YYYY hh:mm A')
  },
  formatDateOnly: function (date) {
    return moment(String(date)).format('LL')

    // return moment(String(date)).format(
    //   'DD/MM/YYYY hh:mm:ss A')
  },
  DD_MM_YYYY: function (date) {
    return moment(String(date)).format('DD/MM/YYYY') // 27/08/2020
  },
  DD_MMMM_YYYY: function (date) {
    return moment(String(date)).format('DD MMMM YYYY') // 27 August 2020
  },
  removecodeFromMobileNumber: function (mobileNumberWithCode) {
    let finaMobileNumber = ''
    if (mobileNumberWithCode) {
      finaMobileNumber = mobileNumberWithCode.substr(mobileNumberWithCode.length -
        10)
      return finaMobileNumber
    }
  },
  maskEmail: function (stringtoFilter) {
    if (stringtoFilter.length) {
      let len = stringtoFilter.length
      return stringtoFilter.slice(0, 4) + 'x'.repeat(len - 4)
    } else {
      return '-'
    }
  },
  maskEmailOTP: function (stringtoFilter) {
    if (stringtoFilter.length) {
      let str = stringtoFilter.split('')
      let finalArr = []
      let len = str.indexOf('@')
      str.forEach((item, pos) => {
        (pos >= 4 && pos <= len - 1) ? finalArr.push('*') : finalArr.push(str[pos])
      })
      return finalArr.join('')
    } else {
      return '-'
    }
  },
  maskMobile: function (stringtoFilter) {
    if (Number(stringtoFilter.length) === 10) {
      return stringtoFilter.slice(0, 2) + 'x'.repeat(stringtoFilter.length - 4) + stringtoFilter.slice(-2)
    } else {
      return '-'
    }
  }
}



// WEBPACK FOOTER //
// ./src/filters/filter.js